module.exports = __webpack_public_path__ + "img/person.e74b4d72.png";